import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { IgSheet } from './IgKit';

export const moisLabel = (m) => { const t = new Date(`${m}-01T12:00:00`).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }); return t.charAt(0).toUpperCase() + t.slice(1); };
export const moisCourant = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}`; };

// Bouton grisé qui dit pourquoi au tap (règle 4)
// LOT 18.0 · flèche grisée, sans bulle qui sortirait de l'écran
export const grise = (cond, pourquoi, fn) => ({ 'aria-disabled': cond || undefined, style: cond ? { opacity: 0.35, pointerEvents: 'none' } : undefined, onClick: (e) => (cond ? null : fn(e)) });
export const PAS_COMMENCE = 'Mois suivant · le mois n’est pas commencé';

// Le choix du mois · demi-feuille des 12 derniers mois
export const ChoixMois = ({ mois, onChoix, kicker, testId, className = 'fig-pill is-dark', label }) => {
  const [open, setOpen] = useState(false);
  const now = new Date();
  const liste = Array.from({ length: 12 }, (_, i) => { const d = new Date(now.getFullYear(), now.getMonth() - i, 15); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; });
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)} data-testid={testId}>{label || moisLabel(mois)}</button>
      <IgSheet open={open} onClose={() => setOpen(false)} title="Quel mois ?" kicker={kicker} half testId={`${testId}-sheet`}>
        <div className="fig fig-lieux">{liste.map((m) => <button key={m} type="button" className={`fig-lieu ${m === mois ? 'is-on' : ''}`} onClick={() => { setOpen(false); if (m !== mois) onChoix(m); }} data-testid={`${testId}-${m}`}>{moisLabel(m)}</button>)}</div>
      </IgSheet>
    </>
  );
};

// Règle 4 · un bouton grisé n'est jamais muet : au tap, il dit pourquoi (data-pourquoi, sinon title, sinon la règle générale)
export const PourquoiGrise = () => {
  useEffect(() => {
    let dernier = 0;
    const h = (e) => {
      const b = e.target.closest?.('button:disabled, [aria-disabled="true"]');
      if (!b || b.getAttribute('aria-busy') === 'true' || (b.textContent || '').includes('…') || Date.now() - dernier < 800) return;
      if (b.getAttribute('aria-disabled') === 'true' && !b.disabled) return;
      dernier = Date.now();
      toast(b.dataset.pourquoi || b.getAttribute('title') || 'Pas encore possible · complétez ce qui manque au-dessus', { id: 'pourquoi-grise' });
    };
    document.addEventListener('pointerdown', h, true);
    return () => document.removeEventListener('pointerdown', h, true);
  }, []);
  return null;
};
